import script from "./Provider.vue?vue&type=script&setup=true&lang=js"
export * from "./Provider.vue?vue&type=script&setup=true&lang=js"

import "./Provider.vue?vue&type=style&index=0&id=48a8266d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a8266d"]])

export default __exports__